// (function () {
//     'use strict';

//     angular.module("imApp").factory("selectPoFinishService", ['$ihttp', function ($ihttp) {
//         let service = {
//             listFinishedProductionOrders: function (parms) {
//                 return $ihttp.post({
//                     method: 447,
//                     parameters: parms || {}
//                 });
//             },
//             listProductionOrders: function (parms) {
//                 return $ihttp.post({
//                     method: 493,
//                     parameters: parms || {}
//                 });
//             },
//             saveItem: function (item) {
//                 return $ihttp.post({
//                     method: 448,
//                     parameters: item
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
